module.exports = __webpack_public_path__ + "static/media/PC-banner1.a4512ec9.jpg";